module.exports = __webpack_public_path__ + "img/96eec85.jpg";